import { render, staticRenderFns } from "./UniqueC.vue?vue&type=template&id=b6bfd50e&"
import script from "./UniqueC.vue?vue&type=script&lang=js&"
export * from "./UniqueC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports